module.exports = __webpack_public_path__ + "assets/pregnant.42f5037c.png";